import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { BaseUrlInvoice } from "../formcomponents/Constants";
import { useReactToPrint } from "react-to-print";
import { Button, Grid, Table, Header } from "semantic-ui-react";
import axios from "axios";
const DailyworkPdf = () => {
  const { id } = useParams();
  const [objectData, setobjectData] = useState();
  useEffect(() => {
    getWorkDetails(id);
  }, []);

  const getWorkDetails = (id) => {
    console.log("work id", id);
    axios
      .post(BaseUrlInvoice + "accounts/getDailyWorkDetails", {
        dailyWorkId: id,
      })
      .then((res) => {
        console.log(res.data);
        setobjectData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "INVOICE",
    onAfterPrint: () => alert("print SUCCESS"),
  });
  const calculateGrandTotal = (data) => {
    let grandTotal = 0;

    if (data) {
      data.forEach((item) => {
        if (item && typeof item.finalAmount === "number") {
          grandTotal += item.finalAmount;
        }
      });
    }

    return grandTotal;
  };

  const stylesForPrint = `
  @media print {
    @page {
      margin: 20mm; /* Set margins */
    }
    body {
      margin: 0; /* Reset body margins */
    }
    .page-break {
      page-break-after: always; /* Ensure content breaks into a new page */
      margin-bottom: 50px; /* Set bottom space */
    }
  }
`;
  return (
    <div>
      <div
        style={{
          padding: 10,
          marginBottom: 35,
        }}
      >
        <Button floated="right" onClick={handlePrint}>
          print
        </Button>
      </div>
      <div style={{ minHeight: "100vh", position: "relative" }}>
        <div style={{ paddingBottom: "50px" }}>
          <div
            ref={componentRef}
            style={{
              width: "100%",
              height: window.innerHeight,
              padding: 30,
              marginBottom: 35,
            }}
          >
            <style>{stylesForPrint}</style>
            <Grid>
              <Grid.Column width={5} floated="left">
                <Header as="h3">
                  PARMAR GROUP <br />
                  <Header.Subheader as="span">SILVER STAR</Header.Subheader>
                </Header>
              </Grid.Column>
              <Grid.Column width={7}>
                <Header as="h3" textAlign="right">
                  DAILY WORK
                </Header>
                <Table style={{ border: "none" }}>
                  <Table.Body>
                    <Table.Row className="noBottomBorder">
                      <Table.Cell textAlign="left">To</Table.Cell>
                      <Table.Cell textAlign="right">
                        {objectData?.toOrBy}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row className="noBottomBorder">
                      <Table.Cell textAlign="left">For</Table.Cell>
                      <Table.Cell textAlign="right">
                        {objectData?.forWork}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row className="noBottomBorder">
                      <Table.Cell textAlign="left">Date</Table.Cell>
                      <Table.Cell textAlign="right">
                        {objectData?.workDate}
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Grid.Column>
            </Grid>

            <div className="page-break">
              <Table>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell
                      width={2}
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Company Name
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Item
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Qty
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Price
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Amount
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Discount
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Total
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {objectData?.workDetailsList?.map((item, index) => (
                    <Table.Row>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.item}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.description}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.quantity}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.unitPrice}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.amount}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.discount}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.finalAmount}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                  <Table.Row>
                    <Table.Cell
                      style={{
                        padding: "5px",
                      }}
                    ></Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}></Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}></Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}></Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}></Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}>
                      <b>
                        <h3>Total</h3>
                      </b>
                    </Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}>
                      {" "}
                      <b>
                        <h3>
                          {calculateGrandTotal(objectData?.workDetailsList)}
                        </h3>
                      </b>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </div>

            {/* <div
              style={{
                backgroundColor: "#f0f0f0",
                width: "100%",
                position: "absolute",
                bottom: 0,
                left: 0,
                textAlign: "center",
                padding: "10px",
              }}
            >
              <h4> Thank you for your business</h4>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailyworkPdf;
